import styled from 'styled-components';

export const Full = styled.div`
  width: 100%;
  height: 100%;
`;
